import React from 'react';
/*We use Switch and Route to generate the routes of each menu item*/
import { Switch, Route } from "react-router-dom";
import './App.css';

import { COMPLETE_MODULES } from './assets/config'

/*Custom Components*/
import Header from './components/Header/header';
import Menu from './components/Menu/menu';
import Home from './components/Home/home';
import PrivateRoute from './components/PrivateRoute/privateRoute';
import Login from './components/Login/login';
import ForgotPassword from './components/ForgotPassword/forgotPassword';
import ChangePassword from './components/ChangePassword/changePassword';
import Log from './components/SystemLog/systemLog';
import AuthInstitutions from './components/AuthInstitutions/authInstitutions';
import ExternalAuth from './components/ExternalAuth/externalAuth';
import Model from './components/Models/model'
import Scenario from './components/Scenarios/scenario'
import Wizard from './components/Models/wizard'
import SPFunctions from './components/SPFunctions/spFunctions';
import SPComponents from './components/SPComponents/spComponents';
import PopGroups from './components/PopGroups/popGroups';
import Benefit from './components/Benefit/benefit';
import Dashboard from './components/Scenarios/dashboard';
import Footer from './components/Footer/footer';
import ScenarioAddBenefit from './components/Scenarios/scenarioAddBenefit';
import ModelReports from './components/Models/modelReports'


import MatrixControl from './components/Scenarios/matrixControl'
import GraphControl from './components/GraphControl/graphControl';

/*Authorization components*/
import AuthState from './context/Auth/AuthState';
import { ToastContainer } from 'react-toastify';

const UnderConstruction = (props) => {
    return (
        <div className="container-fluid text-center p-4">
            <h1>{props.name}</h1>
            <h3>Under Construction</h3>
        </div>
    )
}


function App() {
    return (
        <AuthState>
            <div className="container-fluid">
                {/* Header is render */}
                <Header />

                {/* Menu is render */}
                <Menu />

                {/**This is part of the react-router to know which route to render.*/}


                <Switch>
                    <Route path="/ExtAuth">
                        <ExternalAuth />
                    </Route>

                    <Route path="/Login">
                        <div className="body_container">
                            <Login />
                        </div>
                    </Route>

                    <Route path="/ForgotPassword">
                        <div className="body_container">
                            <ForgotPassword />
                        </div>
                    </Route>

                    <PrivateRoute path="/ChangePassword">
                        <div className="body_container">
                            <ChangePassword firstime={false} />
                        </div>
                    </PrivateRoute>

                    <PrivateRoute path="/FirstTime">
                        <div className="body_container">
                            <ChangePassword firstime={true} />
                        </div>
                    </PrivateRoute>

                    <PrivateRoute path="/AuthInstitutions">
                        <div className="body_container">
                            <AuthInstitutions />
                        </div>
                    </PrivateRoute>

                    <PrivateRoute path="/SpFunctions">
                        {COMPLETE_MODULES.spFunction ?
                            <div className="body_container"><SPFunctions /></div> :
                            <UnderConstruction name="Sp Functions" />
                        }
                    </PrivateRoute>

                    <PrivateRoute path="/SpComponents">
                        {COMPLETE_MODULES.spComponents ?
                            <div className="body_container"><SPComponents /></div> :
                            <UnderConstruction name="Sp Componets" />
                        }
                    </PrivateRoute>

                    <PrivateRoute path="/PopGroups">
                        {COMPLETE_MODULES.pGroups ?
                            <div className="body_container"><PopGroups /></div> :
                            <UnderConstruction name="PopGroups" />
                        }
                    </PrivateRoute>

                    <PrivateRoute path="/Benefits">
                        {COMPLETE_MODULES.benefits ?
                            <div className="body_container"><Benefit /></div> :
                            <UnderConstruction name="Benefits" />
                        }
                    </PrivateRoute>

                    <PrivateRoute path="/Models">
                        {COMPLETE_MODULES.models ?
                            <div className="body_container"><Model /></div> :
                            <UnderConstruction name="Models" />
                        }
                    </PrivateRoute>

                    <PrivateRoute path="/ModelReports">
                        {COMPLETE_MODULES.models ?
                            <div className="body_container"><ModelReports /></div> :
                            <UnderConstruction name="ModelReports" />
                        }
                    </PrivateRoute>

                    <PrivateRoute path="/Wizard">
                        {COMPLETE_MODULES.wizard ?
                            <div className="body_container_wizard"><Wizard /></div> :
                            <UnderConstruction name="Wizard" />
                        }
                    </PrivateRoute>

                    <PrivateRoute path="/AddScenarioBenefit">
                        {COMPLETE_MODULES.scenarios ?
                            <div className="body_container"><ScenarioAddBenefit /></div> :
                            <UnderConstruction name="Wizard" />
                        }
                    </PrivateRoute>

                    <PrivateRoute path="/Scenarios">
                        {COMPLETE_MODULES.scenarios ?
                            <div className="body_container">< Scenario /></div> :
                            <UnderConstruction name="Scenarios" />
                        }
                    </PrivateRoute>

                    <PrivateRoute path="/MatrixControl">
                        {COMPLETE_MODULES.scenarios ?
                            <div className="body_container">< MatrixControl /></div> :
                            <UnderConstruction name="Matrix control" />
                        }
                    </PrivateRoute>

                    <PrivateRoute path="/Dashboard">
                        {COMPLETE_MODULES.wizard ?
                            <div className="body_container"><Dashboard /></div> :
                            <UnderConstruction name="Dashboard" />
                        }
                    </PrivateRoute>

                    <PrivateRoute path="/Graph">
                        <div className="body_container">
                            <GraphControl />
                        </div>
                    </PrivateRoute>

                    <PrivateRoute path="/Log">
                        {COMPLETE_MODULES.log ?
                            <div className="body_container"><Log /></div> :
                            <UnderConstruction name="System Log" />
                        }
                    </PrivateRoute>

                    <PrivateRoute path="/" exact>
                        <div className="body_container">
                            <Home />
                        </div>
                    </PrivateRoute>

                    <Route path="*">
                        <div className="body_container">
                            <h1>404</h1>
                        </div>
                    </Route>
                </Switch>


                <ToastContainer />
            </div>
            <Footer />

        </AuthState>
    );
}

export default App;
